export const formatPlanPrice = (price) => {
  if (!price || typeof price.amountCents !== "number") return "";
  const dollars = price.amountCents / 100;
  const amount = Number.isInteger(dollars)
    ? `$${dollars}`
    : `$${dollars.toFixed(2)}`;
  const interval = price.interval === "month" ? "month" : "year";
  return `${amount}/${interval}`;
};

const formatPeriodEnd = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

export const planStatusCopy = ({
  state,
  plan,
  paymentFailed,
  disputed,
  cancelAtPeriodEnd,
  currentPeriodEnd,
  trialTournamentName,
  hasAnyTournament,
} = {}) => {
  let label = "Off";
  let detail = hasAnyTournament
    ? "AI Assist is off. Free includes up to 5 tournaments per year."
    : "Your first tournament includes AI Assist at no charge. Free includes up to 5 tournaments per year.";

  if (state === "subscribed" && plan === "priority") {
    label = "Priority";
    detail =
      "Priority is on. It includes AI Assist on every tournament and unlimited tournaments per year.";
  } else if (state === "subscribed") {
    label = "AI Assist";
    detail =
      "AI Assist is on for every tournament in this organization. This plan includes up to 20 tournaments per year.";
  } else if (state === "beta") {
    label = "Beta";
    detail =
      "AI Assist is on for this organization from the beta. It stays on without a paid plan until that beta ends. Tournament creates are unlimited while the beta grant is on.";
  } else if (state === "trial") {
    label = "Trial";
    detail = trialTournamentName
      ? `AI Assist is on for ${trialTournamentName}, the first tournament. Other tournaments need AI Assist or Priority. Free includes up to 5 tournaments per year.`
      : "AI Assist is on for the first tournament. Other tournaments need AI Assist or Priority. Free includes up to 5 tournaments per year.";
  }

  let cancelNote = "";
  if (cancelAtPeriodEnd && state === "subscribed") {
    const when = formatPeriodEnd(currentPeriodEnd);
    const priority = plan === "priority";
    const planName = priority ? "Priority" : "AI Assist";
    cancelNote = when
      ? `${planName} stays on through ${when}, then ends.`
      : `${planName} stays on through the end of the year you paid, then ends.`;
    const includes = priority
      ? "It includes AI Assist on every tournament and unlimited tournaments per year."
      : "This plan includes up to 20 tournaments per year.";
    detail = `${cancelNote} ${includes}`;
  }

  let paymentNote = "";
  if (paymentFailed && state === "subscribed") {
    paymentNote =
      "Your card didn’t go through. Update it in Manage billing. AI imports stay on while we retry.";
  } else if (paymentFailed && state === "off") {
    paymentNote =
      "Your card didn’t go through. Update it in Manage billing. AI imports are off until the card is updated.";
  } else if (paymentFailed) {
    paymentNote =
      "Your card didn’t go through. Update it in Manage billing.";
  }

  return {
    label,
    detail,
    cancelNote,
    paymentNote,
    disputeNote: disputed ? "A subscription charge is disputed." : "",
  };
};

/**
 * Cap line for Plan. Paid AI Assist never shows Unlimited (even if a grace
 * grandfather grant still makes the DB limit null).
 */
export const planCapDisplayLimit = ({ state, plan, tournamentLimit } = {}) => {
  if (state === "subscribed" && plan === "ai_assist") return 20;
  if (state === "subscribed" && plan === "priority") return null;
  if (tournamentLimit === undefined) return undefined;
  return tournamentLimit == null ? null : Number(tournamentLimit);
};
